var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"title":((_vm.context.projectName) + " " + (_vm.$t('description')))}},[_c('span',{staticClass:"break-word"},[_vm._v(_vm._s(_vm.context.projectDescription))])])}
var staticRenderFns = []

export { render, staticRenderFns }